import BaseTable from './BaseTable';


class CustomerTable extends BaseTable {

}

export default CustomerTable;
